import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import Api from 'lib/api/Api';

import { openModal } from 'store/v1/ui/ui.actions.js';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from 'v5/design-system/DropdownMenu.js';
import { Button } from 'v5/design-system/Button.js';
import { CloudDownload, MoreHorizontal, PenTool } from 'lucide-react';

// TODO: this was ripped out of BudgetSidebar and needs bringing up to date
const ProductionBudgetOptions = ({ productionId, shape, variant }) => {
  const dispatch = useDispatch();
  const productions = useSelector(store => store.productions);
  const production = get(productions, ['data', productionId], {});

  const makeExportURL = section => {
    return Api.formatUrl(
      `/productions/${productionId}/budgets/${section}/export`
    );
  };

  return (
    <div className="contents tailwind-root">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            size="sm"
            layout="icon"
            shape={shape}
            variant={variant ?? 'secondary'}
          >
            <MoreHorizontal />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem
            size="lg"
            onSelect={() => {
              dispatch(openModal('BudgetSettingsModal', { production }));
            }}
          >
            <PenTool />
            Budget settings
          </DropdownMenuItem>

          <DropdownMenuItem size="lg" asChild>
            <a
              href={makeExportURL('estimated')}
              target="_blank"
              rel="noreferrer"
            >
              <CloudDownload />
              Download estimated budget
            </a>
          </DropdownMenuItem>

          <DropdownMenuItem size="lg" asChild>
            <a
              href={makeExportURL('committed')}
              target="_blank"
              rel="noreferrer"
            >
              <CloudDownload />
              Download committed budget
            </a>
          </DropdownMenuItem>

          <DropdownMenuItem size="lg" asChild>
            <a href={makeExportURL('actuals')} target="_blank" rel="noreferrer">
              <CloudDownload />
              Download actuals budget
            </a>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};

ProductionBudgetOptions.propTypes = {
  productionId: PropTypes.number
};

export default ProductionBudgetOptions;
